import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Input,
  InputLabel,
  Box,
  TextField,
  Autocomplete,
  Select,
  MenuItem,
} from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useFormik } from 'formik'
import { inject, observer } from 'mobx-react'
import { Tag, Tooltip, Upload, message, Button } from 'antd'
import RichEditor from '../../components/RichEditor/RichEditor'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers'
import queryString from 'query-string'
import * as Yup from 'yup'
import {
  AiFillBank,
  AiOutlineDelete,
  AiOutlineFolder,
  AiOutlineTeam,
  AiOutlineUpload,
  AiOutlineUser,
} from 'react-icons/ai'
import {
  BankOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  FileTextOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { ASSIGNEE_TYPE } from '../../utils/constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'
import { AvatarHasName } from '../../components/common/Avatar'
import '../../components/RichEditor/RichEditor.scss'
import { MyUploadAdapter } from './../../components/RichEditor/MyUploadAdapter'
import { useNavigate } from 'react-router-dom'
import PopupRenameFile from '../../components/PopupRenameFile/PopupRenameFile'
import utils from '../../utils'
import { TASK_DOCUMENT_TYPE, WORK_STATUS } from '../../constants'
import moment from 'moment'
import { SelectList } from '../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled'
import { ButtonsWrapper, DocumentList } from './MissionCreatePafeStyled'
import { blue, green } from '../../color'
import { EmptyText } from '../../components/common/CellText'
import ModalIncomingDocumentList from './ModalIncomingDocumentList'
import ModalOutgoingDocumentList from './ModalOutgoingDocumentList'
import EmptyContent from '../../components/common/EmptyContent/EmptyContent'
import { TaskRequest } from '../../requests/TaskRequest'
import dayjs from 'dayjs'

const { Option } = Select
const toolbar = [
  'insertTable',
  'Alignment',
  'Autoformat',
  'AutoLink',
  'BlockQuote',
  'Bold',
  'Essentials',
  'FontBackgroundColor',
  'FontColor',
  'FontFamily',
  'FontSize',
  'Heading',
  'Image',
  'ImageInsert',
  'ImageResize',
  'ImageStyle',
  'ImageToolbar',
  'ImageUpload',
  'Indent',
  'IndentBlock',
  'Italic',
  'Link',
  'List',
  'ListStyle',
  'MediaEmbed',
  'MediaEmbedToolbar',
  'Mention',
  'Paragraph',
  'PasteFromOffice',
  'Strikethrough',
  'Table',
  'TableCellProperties',
  'TableProperties',
  'TableToolbar',
  'TextTransformation',
  'TodoList',
  'Underline',
  'WordCount',
]
const date = new Date()
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
const CreateModal = props => {
  let {
    params,
    open,
    code,
    loadingAnimationStore,
    handleClose,
    selectPeopleStore,
    fileStore,
    queryStringParsed,
    createMessage,
    setCheck,
    check,
    internalDocumentStore,
    taskStore,
    filter,
  } = props
  const { taskLevelList, selectedIncomingDocument, selectedOutgoingDocument } =
    taskStore
  const CONTENT_REF = useRef()
  const NOTE_REF = useRef()
  const [editorState, setEditorState] = useState(null)

  useEffect(() => {
    if (editorState) {
      const editor = editorState
      editor.plugins.get('FileRepository').createUploadAdapter = function (
        loader
      ) {
        return new MyUploadAdapter(loader)
      }

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        )

      editor.editing.view.change(writer => {
        writer.setStyle(
          'height',
          '200px',
          editor.editing.view.document.getRoot()
        )
      })
    }
  }, [editorState])
  const [fileExt, setFileExt] = useState(undefined)
  const [fileTargetRename, setFileTargetRename] = useState(null)
  const [fileFromDocumentList, setFileFromDocumentList] = useState([])
  const [fileFromDocumentListv2, setFileFromDocumentListv2] = useState([])
  const [leaderList, setLeaderList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [fileList, setFileList] = useState([])
  const [fileListv2, setFileListv2] = useState([])
  const [data, setData] = useState('')
  const [datav2, setDatav2] = useState('')
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false)
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false)
  // Incoming document
  const [isVisibleModalIncomingDocument, setIsVisibleModalIncomingDocument] =
    useState(false)
  // Ougoing document
  const [isVisibleModalOutgoingDocument, setIsVisibleModalOutgoingDocument] =
    useState(false)
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
  } = selectPeopleStore
  const [selectedTaskLevel, setSelectedTaskLevel] = useState('')
  const [selectedTaskList, setSelectedTaskList] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const handleChangeTaskList = event => {
    setSelectedTaskList(event.target.value)
  }
  const handleChange = event => {
    setSelectedTaskLevel(event.target.value)
  }
  useEffect(() => {
    ;(async () => {
      try {
        await taskStore.getTaskLevelList()
      } catch (err) {
        // console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      }
    })()
    return () => {
      taskStore.clearCreateMissionStore()
    }
  }, [])
  const [tagList, setTagList] = useState([])
  useEffect(() => {
    ;(async () => {
      await TaskRequest.getTagList().then(res => {
        setTagList(
          res.data.map(tag => ({
            code: tag.code,
            name: tag.name,
            type: tag.type,
          }))
        )
      })
    })()
  }, [])
  // console.log(JSON.stringify(tagList))
  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setLeaderList([
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const updateAssignees = useCallback(() => {
    const newAssignees = [...leaderList, ...handlerList, ...combinerList].map(
      el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: el.permission,
      })
    )
    formik.setFieldValue('assignees', newAssignees)
  }, [leaderList, handlerList, combinerList])

  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const res = response
      .map(response => response.data.file_id)
      .concat(fileFromDocumentList.map(file => file.file_id))
    formik.setFieldValue('attachments', res)
  }, [fileList, fileFromDocumentList])
  const updateAttachmentsv2 = useCallback(async () => {
    const uploadFileList = fileListv2.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const res = response
      .map(response => response.data.file_id)
      .concat(fileFromDocumentListv2.map(file => file.file_id))
    formik.setFieldValue('attachments', res)
  }, [fileListv2, fileFromDocumentListv2])

  useEffect(() => {
    formik.setFieldValue('content', data)
  }, [data])
  useEffect(() => {
    formik.setFieldValue('note', datav2)
  }, [datav2])

  useEffect(() => {
    updateAttachments()
    updateAttachmentsv2()
    updateAssignees()
    formik.setFieldValue('parent_id', code)
  }, [updateAssignees, updateAttachments, updateAttachmentsv2])
  const navigate = useNavigate()
  const formik = useFormik({
    initialValues: {
      assignees: [],
      attachments: [],
      content: '',
      note: '',
      ngay_bat_dau: '',
      ngay_ket_thuc: '',
      related_documents: [],
      title: '',
      parent_id: '',
      work_type: 'OTHER',
    },
    validationSchema: Yup.object({
      // title: Yup.string()
      //   .required('Vui lòng nhập tiêu đề !')
      //   .matches(/^(?=.*\S).+$/, 'Vui lòng nhập tiêu đề !'),
      // start_date: Yup.string().required('Vui lòng chọn ngày bắt đầu !'),
      // assignees: Yup.array().min(1, 'Vui lòng chọn người xử lý !'),
    }),
    onSubmit: async values => {
      setButtonBlock(true)
      try {
        // Handle file uploads
        const documentFileResponse = await Promise.all(
          handleUpdateFile(fileList)
        )
        const fileResponse = await Promise.all(handleUpdateFile(fileListv2))

        // Related documents
        const documentList = [
          ...selectedIncomingDocument.map(el => ({
            code_van_ban: el.code,
            type: TASK_DOCUMENT_TYPE.INCOMING,
          })),
          ...selectedOutgoingDocument.map(el => ({
            code_van_ban: el.code,
            type: TASK_DOCUMENT_TYPE.OUTGOING,
          })),
        ]

        // Assignee list
        const assigneesList = [
          ...leaderList,
          ...handlerList,
          ...combinerList,
        ].map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))

        // Prepare submit data
        const submitData = {
          ghi_chu: NOTE_REF.current.editor.getData(),
          id_cap_giao: selectedTaskLevel,
          id_don_vi: '',
          id_file_dinh_kem_vb: documentFileResponse.map(
            response => response.data.file_id
          ),
          id_file_dinh_kem: fileResponse.map(response => response.data.file_id),
          ngay_bat_dau: startDate ? new Date(startDate) : null,
          ngay_ket_thuc: endDate ? new Date(endDate) : null,
          noi_dung: CONTENT_REF.current.editor.getData(),
          van_ban_lq: documentList,
          gui_thong_bao: '001',
          assignees: assigneesList,
          tag_codes: [selectedTaskList],
        }

        // Submit the task creation data
        loadingAnimationStore.showSpinner(true)
        await taskStore.createTask(submitData)
        loadingAnimationStore.showSpinner(false)
        createMessage('Tạo nhiệm vụ thành công!', true, 'success')
      } catch (err) {
        // console.error(err)
      } finally {
        close()
      }
    },
  })

  const close = () => {
    setButtonBlock(false)
    formik.resetForm()
    params({
      page: 0,
      size: 10,
      date_by: 'DISPLAY_DATE',
      from_date: moment(firstDay).format('YYYY-MM-DD'),
      to_date: moment(lastDay).format('YYYY-MM-DD'),
    })
    setCheck(!check)
    setData('')

    setAdvanceFilter({
      ...advanceFilter,
      month: '',
    })
    setAdvanceFilterEnd({
      ...advanceFilter,
      month: '',
    })
    setFileFromDocumentList([])
    selectPeopleStore.clearSelected()
    setFileList([])
    setHandlerList([])
    setLeaderList([])
    setCombinerList([])
    handleClose()
  }
  const handleChangeStart = value => {
    if (value && (!endDate || dayjs(value).isBefore(endDate))) {
      setStartDate(value)
    } else {
      alert('Ngày bắt đầu không thể muộn hơn ngày kết thúc!')
    }
  }

  const handleChangeEnd = value => {
    if (value && (!startDate || dayjs(value).isAfter(startDate))) {
      setEndDate(value)
    } else {
      alert('Ngày kết thúc không thể sớm hơn ngày bắt đầu!')
    }
  }
  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.name),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.name))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }
  const [advanceFilter, setAdvanceFilter] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const [advanceFilterEnd, setAdvanceFilterEnd] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const handleFileChange = useCallback(async info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])
  const handleFileChangev2 = useCallback(async info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileListv2(filteredFileList)
  }, [])
  const handleRemoveFileFromDocumentList = file_id => {
    const newFileList = fileFromDocumentList.filter(
      file => file.file_id !== file_id
    )
    setFileFromDocumentList(newFileList)
  }
  const handleRemoveFileFromDocumentListv2 = file_id => {
    const newFileList = fileFromDocumentList.filter(
      file => file.file_id !== file_id
    )
    setFileFromDocumentListv2(newFileList)
  }
  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }
  const handleRemoveFileFromUploadListv2 = fileUID => {
    const newFileList = fileListv2.filter(file => file.uid !== fileUID)
    setFileListv2(newFileList)
  }
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }
  const handleUpdateFile = fileList => {
    const uploadFileList = fileList
      ? fileList.map(file => file.originFileObj)
      : []
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    return batchUploadArr
  }
  const [buttonBlock, setButtonBlock] = useState(false)
  const handleOpenModalIncomingDocumentList = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await internalDocumentStore.getInternalDocumentIncomingSystemList()
      setIsVisibleModalIncomingDocument(true)
    } catch (err) {
      // console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleOpenModalOutgoingDocumentList = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await internalDocumentStore.getInternalDocumentOutgoingSystemList()
      setIsVisibleModalOutgoingDocument(true)
    } catch (err) {
      // console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  return (
    <Dialog
      open={open}
      onClose={close}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw', // Set your width here
            mx: 0,
            zIndex: 1,
          },
        },
      }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: '#2C65AC',
          }}>
          <span className="font-bold">Tạo nhiệm vụ mới</span>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ paddingBottom: '10px' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Nội dung:
            </InputLabel>
            <RichEditor
              EDITOR_REF={CONTENT_REF}
              editorContent={formik.values.content}
              setData={setData}
              placeholder={'Nhập nội dung...'}
            />
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Ghi chú:
            </InputLabel>
            <RichEditor
              EDITOR_REF={NOTE_REF}
              editorContent={formik.values.note}
              setData={setDatav2}
              placeholder={'Nhập nội dung...'}
            />
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <span style={{ marginRight: 20 }}>Văn bản liên quan:</span>
            <ButtonsWrapper>
              <Button
                size={'small'}
                className="flex justify-center items-center pt-[2px]"
                onClick={handleOpenModalIncomingDocumentList}
                icon={<CopyOutlined style={{ color: green }} />}>
                VB đến
              </Button>
              <Button
                size={'small'}
                className="flex justify-center items-center pt-[2px]"
                onClick={handleOpenModalOutgoingDocumentList}
                icon={<CopyOutlined style={{ color: blue }} />}>
                VB đi
              </Button>
            </ButtonsWrapper>
            {!selectedIncomingDocument.length &&
            !selectedOutgoingDocument.length ? (
              <EmptyText>Bạn chưa chọn văn bản nào</EmptyText>
            ) : (
              <DocumentList>
                {selectedIncomingDocument.map(el => (
                  <li key={el.code}>
                    <CopyOutlined style={{ color: green, marginRight: 8 }} />
                    {`${el.document_number} - ${el.title}`}
                  </li>
                ))}
                {selectedOutgoingDocument.map(el => (
                  <li key={el.code}>
                    <CopyOutlined style={{ color: blue, marginRight: 8 }} />
                    {`${el.document_number} - ${el.title}`}
                  </li>
                ))}
              </DocumentList>
            )}
          </Box>
          <Box>
            <div className="my-2">Tài liệu đính kèm văn bản:</div>
            <Upload
              valuePropName={'fileList'}
              fileList={fileList}
              multiple={true}
              onChange={handleFileChange}
              beforeUpload={() => false}
              showUploadList={false}>
              <Button
                variant="contained"
                className="gap-1 flex items-center justify-center bg-[#1976d2] py-[20px]">
                <AiOutlineUpload />
                Tài liệu đính kèm văn bản
              </Button>
            </Upload>
          </Box>
          {fileFromDocumentList.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileFromDocumentList.map(file => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.file_id}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span
                      onClick={() =>
                        fileStore.handleDownloadFile(
                          file.file_id,
                          file.file_name
                        )
                      }
                      style={{ color: '#1890FF' }}>
                      {file.file_name}
                    </span>
                  </div>
                  <AiOutlineDelete
                    className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                    onClick={() =>
                      handleRemoveFileFromDocumentList(file.file_id)
                    }
                  />
                </li>
              ))}
            </ul>
          )}
          {fileList.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileList.map((file, index) => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.uid}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span style={{ color: '#1890FF' }}>{file.name}</span>
                  </div>
                  <div className="flex items-center">
                    <AiOutlineDelete
                      className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                      onClick={() => handleRemoveFileFromUploadList(file.uid)}
                    />
                  </div>
                </li>
              ))}
            </ul>
          )}
          <Box>
            <div className="my-2">Tài liệu đính kèm:</div>
            <Upload
              valuePropName={'fileListv2'}
              fileList={fileListv2}
              multiple={true}
              onChange={handleFileChangev2}
              beforeUpload={() => false}
              showUploadList={false}>
              <Button
                variant="contained"
                className="gap-1 flex items-center justify-center bg-[#1976d2] py-[20px]">
                <AiOutlineUpload />
                Tài liệu đính kèm
              </Button>
            </Upload>
          </Box>
          {fileFromDocumentListv2.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileFromDocumentListv2.map(file => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.file_id}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span
                      onClick={() =>
                        fileStore.handleDownloadFile(
                          file.file_id,
                          file.file_name
                        )
                      }
                      style={{ color: '#1890FF' }}>
                      {file.file_name}
                    </span>
                  </div>
                  <AiOutlineDelete
                    className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                    onClick={() =>
                      handleRemoveFileFromDocumentList(file.file_id)
                    }
                  />
                </li>
              ))}
            </ul>
          )}
          {fileListv2.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileListv2.map((file, index) => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.uid}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span style={{ color: '#1890FF' }}>{file.name}</span>
                  </div>
                  <div className="flex items-center">
                    <AiOutlineDelete
                      className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                      onClick={() => handleRemoveFileFromUploadList(file.uid)}
                    />
                  </div>
                </li>
              ))}
            </ul>
          )}
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              <span className="text-red-500">*</span>Lãnh đạo giao việc:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.LEADER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {leaderList.map(el => (
                  <SelectList>
                    <Tag
                      name="assignees"
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
          {formik.errors.assignees && formik.touched.assignees && (
            <p style={{ color: 'red', fontSize: '12px', marginLeft: '10px' }}>
              {formik.errors.assignees}
            </p>
          )}
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Xử lý chính:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {handlerList.map(el => (
                  <SelectList>
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Người phối hợp:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {combinerList.map(el => (
                  <SelectList>
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                label="Ngày bắt đầu"
                openTo="day"
                views={['year', 'month', 'day']}
                value={startDate}
                onChange={handleChangeStart}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    error={Boolean(formik.errors.ngay_bat_dau)}
                    helperText={formik.errors.ngay_bat_dau}
                    sx={{ '& .MuiInputBase-input': { fontSize: '14px' } }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          {/* {formik.errors.start_date && formik.touched.start_date && (
              <p style={{ color: 'red' }}>{formik.errors.start_date}</p>
            )} */}
          <Box sx={{ paddingBottom: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                label="Ngày kết thúc"
                openTo="day"
                views={['year', 'month', 'day']}
                value={endDate}
                onChange={handleChangeEnd}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    error={Boolean(formik.errors.ngay_ket_thuc)}
                    helperText={formik.errors.ngay_ket_thuc}
                    sx={{ '& .MuiInputBase-input': { fontSize: '14px' } }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <InputLabel id="task-level-select-label">
              Chọn cấp giao nhiệm vụ:
            </InputLabel>
            <Select
              sx={{ width: '100%' }}
              labelId="task-level-select-label"
              id="task-level-select"
              label="Chọn cấp giao nhiệm vụ"
              value={selectedTaskLevel}
              onChange={handleChange}
              displayEmpty
              renderValue={selected => {
                if (selected === '') {
                  return <em>-- Chọn cấp giao nhiệm vụ --</em>
                }
                return taskLevelList.find(
                  taskLevel => taskLevel.id_level === selected
                )?.ten_cap
              }}>
              <MenuItem value="">
                <em>-- Chọn cấp giao nhiệm vụ --</em>
              </MenuItem>
              {taskLevelList.map(taskLevel => (
                <MenuItem key={taskLevel.id_level} value={taskLevel.id_level}>
                  {taskLevel.ten_cap}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <InputLabel id="task-type-select-label">Loại nhiệm vụ:</InputLabel>
            <Select
              sx={{ width: '100%' }}
              labelId="task-type-select-label"
              id="task-type-select"
              label="Chọn loại nhiệm vụ"
              value={selectedTaskList}
              onChange={handleChangeTaskList}
              displayEmpty
              renderValue={selected => {
                if (selected === '') {
                  return <em>-- Chọn loại nhiệm vụ --</em>
                }
                return tagList.find(task => task.code === selected)?.name
              }}>
              <MenuItem value="">
                <em>-- Chọn loại nhiệm vụ --</em>
              </MenuItem>
              {tagList.map(task => (
                <MenuItem key={task.code} value={task.code}>
                  {task.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: '#e3e4e9', position: 'sticky', bottom: '0' }}>
          <Button
            type="button"
            sx={{ fontWeight: 600 }}
            onClick={close}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
            Đóng
          </Button>

          <button
            type="submit"
            sx={{ fontWeight: 600 }}
            className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
            {' '}
            Tạo mới
          </button>
        </DialogActions>
      </form>
      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />

      <ModalIncomingDocumentList
        handleCloseModal={() => setIsVisibleModalIncomingDocument(false)}
        onClearDocument={() => {
          setIsVisibleModalIncomingDocument(false)
          taskStore.setSelectedIncomingDocument([])
        }}
        onSubmitModal={() => setIsVisibleModalIncomingDocument(false)}
        isVisibleModalIncomingDocument={isVisibleModalIncomingDocument}
      />
      <ModalOutgoingDocumentList
        handleCloseModal={() => setIsVisibleModalOutgoingDocument(false)}
        onClearDocument={() => {
          setIsVisibleModalOutgoingDocument(false)
          taskStore.setSelectedOutgoingDocument([])
        }}
        onSubmitModal={() => setIsVisibleModalOutgoingDocument(false)}
        isVisibleModalOutgoingDocument={isVisibleModalOutgoingDocument}
      />
    </Dialog>
  )
}
export default inject(
  'loadingAnimationStore',
  'fileStore',
  'selectPeopleStore',
  'internalDocumentStore',
  'taskStore'
)(observer(CreateModal))
